import { Loader } from "@mantine/core";
import { HeldEmailLoadError } from "./HeldEmailLoadError";

interface Props {
  error?: Error | null;
  loading: boolean;
}

export function HeldEmailQueueErrorState({ error, loading }: Props) {
  if (loading) return <Loader aria-label="Loading pending emails" />;
  return error ? (
    <HeldEmailLoadError error={error} title="Pending emails unavailable" />
  ) : null;
}
